import { useSelector, } from 'react-redux';
import { useEffect, } from 'react';
import { actionFetchSkills, useAppDispatch, IReducerStore, } from '@Store';

let initiated = false;

export const useSkills = (autoload: boolean = true) => {
  const dispatch = useAppDispatch();
  const skills = useSelector((store: IReducerStore) => store.skills);

  useEffect(() => {
    if (!initiated && autoload && !skills.loaded && !skills.loading) {
      initiated = true;
      dispatch(actionFetchSkills());
    }
  }, [autoload, skills.loaded, skills.loading, dispatch, ]);

  return skills;
};
